import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { OtherInformation } from "./OtherInformation";
import { FlightInformation } from "./FlightInformation";
import { BusinessSource } from "./BusinessSource";
import WSSelectField from "../../../Components/Select/WSSelect";
import config from "../../../Config/clientConfig.json";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";

export const MiscSale: React.FC<any> = React.memo((props) => {
  const methods = useForm();
  const { handleSubmit, control, register } = methods;
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
  };

  const columns: IColumns[] = [
    {
      header: "Extra Charge",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Remarks",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "QTY",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Amount",
      fieldName: "address",
      tooltip: true,
    },
    
  ];
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Header section */}
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" color={"green"} padding={"1rem"}>
             Miscellaneous Sales
            </Typography>
            <IconButton onClick={() => handleClick("/miscsales")}>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
              />
            </IconButton>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2, p: "1rem" }}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography>Voucher No</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("voucherno")}
                    id="voucherno"
                    name="voucherno"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Paid To</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("paidto")}
                    id="paidto"
                    name="paidto"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Out Let</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSSelectField
                    rules={{ required: true }}
                    {...register("outlet")}
                    id="outlet"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="outlet"
                    options={config.outletConfig.staticOptionData}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Extra Charge</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSSelectField
                    rules={{ required: true }}
                    {...register("extraservice")}
                    id="extraservice"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="extraservice"
                    options={config.extraserviceConfig.staticOptionData}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Amount</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("amount")}
                    id="amount"
                    name="amount"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Discount</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label={""}
                    {...register("discount")}
                    id="discount"
                    name="discount"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSIcons.PercentIcon/>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <WSTextField
                    label={""}
                    {...register("discountper")}
                    id="discountper"
                    name="discountper"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Tax</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("tax")}
                    id="tax"
                    name="tax"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Quantity</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <WSTextField
                    label={""}
                    {...register("quantity")}
                    id="quantity"
                    name="quantity"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                <Typography>Adjustment</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <WSTextField
                    label={""}
                    {...register("adjustment")}
                    id="adjustment"
                    name="adjustment"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Amount Total</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("amounttotal")}
                    id="amounttotal"
                    name="amounttotal"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid> <Grid item xs={12} sm={4}>
                  <Typography>Remark</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                <WSTextAreaField
                  label={""}
                  id={"remark"}
                  name={"remark"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />       
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
                <WSDataGrid id="itemGrid" title="" columns={columns} />
                <Grid container spacing={2} sx={{ mt: 2,justifyContent:"flex-end"}} >
    {/* First Text Field */}
    <Grid item xs={12} sm={4}>
      <Typography>Total Amount</Typography>
      </Grid>
      <Grid item xs={12} sm={5}>

      <WSTextField
        label={""}
        {...register("totalamount")}
        id="totalamount"
        name="totalamount"
        control={control}
        rules={{ required: false }}
      />
    </Grid>
    

    <Grid item xs={12} sm={4}>
      <Typography>Rec. Amount</Typography>
      </Grid>
      <Grid item xs={12} sm={5}>

      <WSTextField
        label={""}
        {...register("recamount")}
        id="recamount"
        name="recamount"
        control={control}
        rules={{ required: false }}
      />
    </Grid>
    
  </Grid>
  <Grid container spacing={2} sx={{ mt: 5,justifyContent:"flex-end"}} >

  <Grid item xs={12} sm={4} >
    <Button variant="outlined" color="success" sx={{width:"10rem"}}>Void</Button>
    </Grid>
      <Grid item xs={12} sm={4}>
            <Button variant="outlined" color="success" sx={{width:"10rem"}}>Update</Button>
    </Grid>
    <Grid item xs={12} sm={4}>
            <Button variant="outlined" color="success" sx={{width:"10rem"}}>Add</Button>
    </Grid>
    </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              backgroundColor: "#333",
              padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid container spacing={2} alignItems="center" gap={3}>
              <Grid item>
                <WSIcons.GTranslateIcon sx={{ color: "white" }} />
              </Grid>
            </Grid>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "green",
                "&:hover": {
                  backgroundColor: "#388e3c",
                },
              }}
            >
              Finish
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
});
